
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { BarChart2 } from 'lucide-react';

interface PollWidgetEmptyProps {
  message?: string;
  icon?: React.ReactNode;
}

const PollWidgetEmpty: React.FC<PollWidgetEmptyProps> = ({ 
  message = "No active polls available at this time.", 
  icon 
}) => {
  return (
    <CardContent className="pt-6">
      <div className="text-center">
        {icon || <BarChart2 size={48} className="mx-auto text-gray-300 mb-2" />}
        <p className="text-gray-500">{message}</p>
      </div>
    </CardContent>
  );
};

export default PollWidgetEmpty;
